import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import Billing from "@/pages/Billing";

export const Route = createFileRoute("/en/account/billing")({
  head: () => ({
    meta: [
      { title: "My subscription | Retail Lemon" },
      { name: "description", content: "Active services, invoices and payment details." },
      { property: "og:title", content: "My subscription | Retail Lemon" },
      { property: "og:description", content: "Active services, invoices and payment details." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <Billing />
    </ProtectedRoute>
  ),
});
